<template>
</template>

<script>
import firebase from 'firebase/app';

export default {
  mounted() {
    console.log("Signing out")
    firebase.auth().signOut().then(() => {
      this.$router.push({ path: '/' })
    })
  }
}
</script>